import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import { buildSearchQuery, comboboxValue, QueryFieldMapping } from "../code/search-query/query-mapper";
import { InputObject } from "../controls/default";

export interface TemplateEventsViewForm {
  readonly event: InputObject;
  readonly template: InputObject;
  readonly isActive: boolean;
}

export const templateEventsViewColumns: DataColumn[] = [
  {
    title: "Event",
    key: "event",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Template Name",
    key: "templateName",
    width: 360,
    sort: true,
  },
  {
    title: "Active",
    key: "isActive",
    width: 192,
    sort: true,
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const templateEventsQueryMappings: QueryFieldMapping[] = [
  { formField: "event", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "template", queryField: "templateUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "isActive", operation: QueryOperation.Equal },
];

export const mapTemplateEventsViewQuery = (values: TemplateEventsViewForm): SearchQuery =>
  buildSearchQuery(values, templateEventsQueryMappings);
